import { Button, Skeleton } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ManageClient from "./ManageClient";
import { privateAxiosIntance } from "../../Config/axios";

export const headers = {
  token: localStorage.getItem("token"),
  Authorization: `Token ${localStorage.getItem("token")}`,
};

const Client = () => {
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const clientsFn = async () => {
    setIsLoading(true);
    try {
      const response = await privateAxiosIntance.get("/client-api/");
      setData(response.data.data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    clientsFn();
  }, []);

  const deleteClientFn = async (client_ids) => {
    try {
      const response = await privateAxiosIntance.delete("/client-api/", {
        data: { client_ids },
      });
      toast.success(response.data.message);
      clientsFn();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="p-0">
      {/* Heading */}
      <p className="my-3  sm:my-0 text-2xl sm:text-4xl md:text-5xl text-center text-blue-900 underline">
        Client
      </p>

      {/* Add / Manage Button */}
      <div className="flex justify-end py-1 items-center">
        <ManageClient
          refetch={clientsFn}
          setSelected={setSelected}
          selected={selected}
        />
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {isLoading
          ? [1, 2, 3, 4, 5, 6].map((i) => (
              <div
                key={i}
                className="flex flex-col p-3 bg-gray-100 rounded shadow-inner"
              >
                <div className="flex flex-col gap-2">
                  <div className="flex items-center justify-between">
                    <Skeleton className="w-32" />
                    <Skeleton className="w-24" />
                  </div>
                  <Skeleton className="w-1/2" />
                  <Skeleton variant="rectangular" height={120} />
                  <Skeleton />
                </div>
              </div>
            ))
          : data?.map((item) => (
              <div
                key={item.id}
                className="flex flex-col justify-between p-3 bg-gray-100 rounded shadow-inner"
              >
                {/* Content */}
                <div>
                  <p className="text-lg sm:text-xl font-semibold">
                    {item.name}
                  </p>

                  <p className="text-sm font-semibold text-black text-opacity-60">
                    {item.designation}
                  </p>

                  <img
                    src={item.logo}
                    alt={item.name}
                    className="w-full h-32 object-contain p-2"
                  />
                </div>

                {/* Actions */}
                <div className="flex flex-col sm:flex-row gap-2 pt-2">
                  <Button
                    fullWidth
                    variant="outlined"
                    onClick={() => setSelected(item)}
                  >
                    Update
                  </Button>

                  <Button
                    fullWidth
                    color="error"
                    variant="outlined"
                    onClick={() => deleteClientFn([item.id])}
                  >
                    Delete
                  </Button>
                </div>
              </div>
            ))}
      </div>
    </div>
  );
};

export default Client;
